.header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 2;

  > * {
    height: 100%;
  }
}
